<template>
  <div class="wrapper">
    <div>
      <img src="@static/images/noLimits.png" alt />
    </div>
    <div>
      <span>{{ seizeText }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    seizeText: {
      default: '暂无权限',
      type: String
    }
  }
};
</script>
<style lang="scss" scoped>
.wrapper {
  padding: 20px 0;
  > div {
    text-align: center;
  }
  img {
    width: 190px;
  }
  span {
    font-size: 14px;
    color: #a8adb7;
  }
}
</style>
